import { Link } from "react-router-dom";
import { api } from "../api.ts";
import { PrizeList, Race } from "../components/Race.tsx";
import { AlertBanner } from "../components/ui.tsx";
import { useAsync } from "../hooks.ts";

const SPAN = new Intl.DateTimeFormat(undefined, { day: "numeric", month: "long" });

/** The same week the kitchen board shows, sized for a phone. */
export function Scores() {
  const { data, error, loading } = useAsync(() => api.scoreboard(0));

  if (error) return <AlertBanner>Couldn’t load the scores. {error}</AlertBanner>;
  if (loading && !data) return <p className="muted">Loading…</p>;
  if (!data) return null;

  return (
    <div>
      <header className="head">
        <div className="head__row">
          <div>
            <span className="eyebrow">Week of {SPAN.format(new Date(data.week.start))}</span>
            <h1 className="head__title">The week</h1>
          </div>
          <div className="offer">
            <span className="offer__value">{data.household.points}</span>
            <span className="eyebrow">points</span>
          </div>
        </div>
        <p className="head__note">
          A job pays a point per five minutes, plus one for every day it was left waiting — so rescuing something nobody
          wanted to do beats ticking off three easy ones.
        </p>
      </header>

      <div className="stats">
        <div className="stat">
          <div className="stat__value">{data.household.jobs}</div>
          <div className="stat__label">Jobs done</div>
        </div>
        <div className="stat">
          <div className="stat__value">{Math.round(data.household.minutes / 6) / 10}h</div>
          <div className="stat__label">Time spent</div>
        </div>
        <div className="stat">
          <div className="stat__value">{data.household.unattributed}</div>
          <div className="stat__label">Uncredited</div>
        </div>
      </div>

      <Race title="Kids" rows={data.boards.kid} markers={data.markers} compact />
      <Race title="Grown-ups" rows={data.boards.parent} markers={data.markers} compact />
      <Race title="Staying with us" rows={data.boards.guest} markers={data.markers} compact />
      <PrizeList markers={data.markers} rows={[...data.boards.kid, ...data.boards.parent, ...data.boards.guest]} />

      <p className="muted" style={{ fontSize: "var(--text-sm)" }}>
        On the kitchen tablet, open <Link to="/board">the board</Link> — full screen, big buttons, refreshes itself.
      </p>
    </div>
  );
}
